<template>
    <div>
        <div class="row template-section">
            <div class="col-lg-1 col-md-1">
                <product-photo
                    :photo_link="photo_link"
                ></product-photo>
            </div>
            <div class="col-lg-6 col-md-6 product-section">
                <product-detail
                    :product_id="product_id"
                    :product_name="product_name"
                    :product_link="product_link"
                    :shop_name="shop_name"
                    :srp_price="srp_price"
                ></product-detail>
                <attributes
                    :attributesSelected="attributesSelected"
                    :attributes="attributes"
                ></attributes>
            </div>
            <div class="col-lg-5 col-md-5">
                <offers
                    :offers="offers"
                ></offers>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductDetail from './productDetail';
    import ProductPhoto from './productPhoto';
    import Offers from './offers';
    import Attributes from './attributes';
    export default
    {
        components: {ProductPhoto, ProductDetail, Offers, Attributes},
        props: {
            attributesSelected: {
                Type: Array,
                Default: []
            }
        },
        data() {
            return {
                product_name: null,
                product_link: null,
                srp_price: null,
                photo_link: null,
                product_id: null,
                offers: [],
                shop_name: null,
                attributes: [],
            };
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style lang="sass">
    .template-section {
        margin-left: 0;
        margin-right: 0;
        min-height: 120px;
    }
    .product-section {
        border-right: 1px solid #ddd;
    }
</style>


// WEBPACK FOOTER //
// template.vue?0ce3264a